import type { UserPermissionsMap } from '@unifyapps/carbon/no-code/access-control/types';
import { filterPermissibleNavItems } from '@unifyapps/carbon/no-code/access-control/utils/filterPermissibleNavItems';
import type { NavItems, PagePermissions } from '@unifyapps/defs/types/interface';
import { useMemo } from 'react';

export const usePermissibleNavItems = ({
  items,
  permissions,
  pagePermissions,
}: {
  items: NavItems | undefined;
  permissions: UserPermissionsMap;
  pagePermissions: PagePermissions | undefined;
}): NavItems | undefined =>
  useMemo(
    () => (items ? filterPermissibleNavItems({ items, permissions, pagePermissions }) : undefined),
    [items, pagePermissions, permissions],
  );
